import PropTypes from 'prop-types'
import { AccountDealerAccessLevel } from '../../models/settings/account-dealer-access-levels-enum'
import { dealerAccessLogEntryPropType } from './dealer-access-log-entry-prop-type'

/**
 * @typedef {Object} accountDealerAccessPropType
 * @property {boolean} [accessEnabled]               - The status of the access (enabled or not)
 * @property {string}  [accessLevel]                 - The access level of the reseller
 * @property {string}  [resellerId]                  - The id of the reseller
 */
export const accountDealerAccessPropType = PropTypes.shape({
    accessEnabled: PropTypes.bool,
    accessLevel: PropTypes.oneOf(Object.values(AccountDealerAccessLevel)),
    accessLog: PropTypes.arrayOf(dealerAccessLogEntryPropType),
    resellerId: PropTypes.string
})
